
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const EmailCampaignForm = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Email Campaign Form</CardTitle>
      </CardHeader>
      <CardContent>
        <p>Email campaign form coming soon...</p>
      </CardContent>
    </Card>
  );
};

export default EmailCampaignForm;
